// The design's routes (DESIGN_SPEC §4: route, orgTab, siteTab, setTab) as URLs.

export const ORG_TABS = ['overview', 'research', 'sites', 'users', 'integrations', 'subscription', 'activity'] as const;
export type OrgTab = (typeof ORG_TABS)[number];

// The design's eight tabs, then «Аналитика» (P8-A05, additive: DESIGN_SPEC §9 C21).
export const SITE_TABS = ['overview', 'research', 'structure', 'variants', 'designer', 'sync', 'domains', 'deploy', 'analytics'] as const;
export type SiteTab = (typeof SITE_TABS)[number];

// The design's six tabs, then the two additive ones (P3-E04, DESIGN_SPEC §9 C7).
export const SETTINGS_TABS = ['ai', 'mcp', 'storage', 'domains', 'rules', 'users', 'catalogs', 'sources'] as const;
export type SettingsTab = (typeof SETTINGS_TABS)[number];

export const paths = {
  dashboard: () => '/',
  organizations: () => '/organizations',
  organization: (id: string, tab?: OrgTab) => (tab ? `/organizations/${id}/${tab}` : `/organizations/${id}`),
  sites: () => '/sites',
  site: (id: string, tab?: SiteTab) => (tab ? `/sites/${id}/${tab}` : `/sites/${id}`),
  library: () => '/library',
  preset: (id: string) => `/library/${id}`,
  plans: () => '/plans',
  settings: (tab?: SettingsTab) => (tab ? `/settings/${tab}` : '/settings'),
  audit: () => '/audit',
  login: () => '/login',
  mfa: () => '/login/mfa',
  designSystem: () => '/__ds',
} as const;

export function isOrgTab(v: string | undefined): v is OrgTab {
  return !!v && (ORG_TABS as readonly string[]).includes(v);
}
export function isSiteTab(v: string | undefined): v is SiteTab {
  return !!v && (SITE_TABS as readonly string[]).includes(v);
}
export function isSettingsTab(v: string | undefined): v is SettingsTab {
  return !!v && (SETTINGS_TABS as readonly string[]).includes(v);
}
